import request from '@/router/axios';

export const getList = (params) => {
  return request({
    url: '/api/produce/transport-contract/select/page',
    method: 'get',
    params
  })
}

export const add = (row) => {
  return request({
    url: '/api/produce/transport-contract/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/transport-contract/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/transport-contract/select/id',
    method: 'get',
    params: {
      id
    }
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/transport-contract/delete/ids',
    method: 'get',
    params: {
      ids
    }
  })
}

